export const PREVIEW_TYPE_MAP = {
    '1': 'training',
    '2': 'reminder_training',
    '3': 'assessment',
    '4': 'reminder_assessment',
    '5': 'welcome',
};

export const SMART_VARIABLES = {
    training: [
        { name: '{{trainingName}}', description: 'Name of the training' },
        { name: '{{recipient}}', description: 'Recipient name' },
    ],
    trainingReminder: [
        { name: '{{trainingName}}', description: 'Name of the training' },
        { name: '{{recipient}}', description: 'Recipient name' },
    ],
    assessment: [
        { name: '{{assessmentName}}', description: 'Name of the assessment' },
        { name: '{{recipient}}', description: 'Recipient name' },
        { name: '{{questionCount}}', description: 'Number of questions in the assessment' },
        { name: '{{assessmentDueDate}}', description: 'Assessment due date' },
    ],
    assessmentReminder: [
        { name: '{{assessmentName}}', description: 'Name of the assessment' },
        { name: '{{recipient}}', description: 'Recipient name' },
        { name: '{{questionCount}}', description: 'Number of questions in the assessment' },
        { name: '{{assessmentDueDate}}', description: 'Assessment due date' },
    ],
    welcome: [
        { name: '{{recipient}}', description: 'Recipient name' },
    ],
};

export const TAB_CONFIG = {
    training: {
        id: '1',
        label: 'Training',
        subjectField: 'training_subject',
        greetingField: 'training_greeting',
        headerField: 'trainingHeader',
        footerField: 'trainingFooter',
        headerLabel: 'Customize Header in training emails',
        footerLabel: 'Customize Footer in training emails',
        smartVariables: 'training',
    },
    trainingReminder: {
        id: '2',
        label: 'Training Reminders',
        subjectField: 'reminder_training_subject',
        greetingField: 'reminder_training_greeting',
        headerField: 'reminderTrainingHeader',
        footerField: 'reminderTrainingFooter',
        headerLabel: 'Customize Header in training reminder emails',
        footerLabel: 'Customize Footer in training reminder emails',
        smartVariables: 'trainingReminder',
    },
    assessment: {
        id: '3',
        label: 'Assessments',
        subjectField: 'assessment_subject',
        greetingField: 'assessment_greeting',
        headerField: 'assessmentHeader',
        footerField: 'assessmentFooter',
        headerLabel: 'Customize Header in assessment emails',
        footerLabel: 'Customize Footer in assessment emails',
        smartVariables: 'assessment',
    },
    assessmentReminder: {
        id: '4',
        label: 'Assessment Reminders',
        subjectField: 'reminder_assessment_subject',
        greetingField: 'reminder_assessment_greeting',
        headerField: 'reminderAssessmentHeader',
        footerField: 'reminderAssessmentFooter',
        headerLabel: 'Customize Header in assessment reminder emails',
        footerLabel: 'Customize Footer in assessment reminder emails',
        smartVariables: 'assessmentReminder',
    },
};

